export function InboundEmail(model = {}) {
  return {
    id: model?.id,
    subject: model?.subject,
    from: model?.from,
    to: model?.to,
    bodyPreview: model?.bodyPreview,
    createdAt: model?.createdAt
  };
}

export function setInboundEmailFromRaw(raw = {}) {
  const model = InboundEmail();
  model.id = raw.id;
  model.subject = raw.subject;
  model.from = raw.from;
  model.to = raw.to;
  model.bodyPreview = raw.body_preview;
  model.createdAt = raw.created_at;
  return model;
}

export function FullInboundEmail(model = {}) {
  return {
    id: model?.id,
    subject: model?.subject,
    from: model?.from,
    to: model?.to,
    body: model?.body,
    attachments: model?.attachments,
    createdAt: model?.createdAt,
    isHtml: model?.isHtml
  };
}

export function setFullInboundEmailFromRaw(raw = {}) {
  const model = FullInboundEmail();
  model.id = raw.id;
  model.subject = raw.subject;
  model.from = raw.from;
  model.to = raw.to;
  model.body = raw.body;
  model.createdAt = raw.created_at;
  model.isHtml = raw.is_html;
  model.attachments = [];
  if (Array.isArray(raw.attachments)) {
    model.attachments = raw.attachments.map(setInboundEmailAttachmentFromRaw);
  }
  return model;
}

function InboundEmailAttachment(model = {}) {
  return {
    filename: model?.filename,
    contentType: model?.contentType,
    size: model?.size,
    downloadUrl: model?.downloadUrl
  };
}

function setInboundEmailAttachmentFromRaw(raw = {}) {
  const model = InboundEmailAttachment();
  model.filename = raw.filename;
  model.contentType = raw.content_type;
  model.size = raw.size;
  model.downloadUrl = raw.download_url;
  return model;
}
